import { render, staticRenderFns } from "./AlertsTable.vue?vue&type=template&id=02706ccd&scoped=true"
import script from "./AlertsTable.ts?vue&type=script&lang=ts&external"
export * from "./AlertsTable.ts?vue&type=script&lang=ts&external"
import style0 from "./AlertsTable.vue?vue&type=style&index=0&id=02706ccd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02706ccd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02706ccd')) {
      api.createRecord('02706ccd', component.options)
    } else {
      api.reload('02706ccd', component.options)
    }
    module.hot.accept("./AlertsTable.vue?vue&type=template&id=02706ccd&scoped=true", function () {
      api.rerender('02706ccd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Alerts/components/AlertsTable/AlertsTable.vue"
export default component.exports